import {CommandClause, CPCLCommand} from "@psdk/frame-father";
import {BasicCPCLArg} from "./basic";

export class CInverse extends BasicCPCLArg<CInverse> {
  private x: number;
  private y: number;
  private width: number;
  private height: number;

  constructor(options?: {
    /**
     * 反色区域起始X坐标
     */
    x?: number
    /**
     * 反色区域起始Y坐标
     */
    y?: number
    /**
     * 反色区域宽
     */
    width?: number
    /**
     * 反色区域高
     */
    height?: number
  }) {
    super();
    this.x = options?.x ?? 0;
    this.y = options?.y ?? 0;
    this.width = options?.width ?? 0;
    this.height = options?.height ?? 0;

  }

  clause(): CommandClause {
    return CPCLCommand.with(this.header())
      .appendNumber(this.x)
      .appendNumber(this.y)
      .appendNumber(this.x + this.width)
      .appendNumber(this.y)
      .appendNumber(this.height)
      .clause();
  }

  header(): string {
    return 'INVERSE-LINE';
  }


}


